<template>
  <div class="mine page">
    <div class="page-bg"></div>
    <div class="wrapper">
      <van-pull-refresh
        v-model="isLoading"
        :pulling-text="$t('common.pulling')"
        :loosing-text="$t('common.loosing')"
        :loading-text="$t('common.loading')"
        :success-text="$t('common.refresh_success')"
        @refresh="onRefresh"
      >
        <div class="header">
          <van-nav-bar class="nav-bar">
            <template #right>
              <van-icon name="setting-o" color="#fff" @click="showSetting()" />
            </template>
          </van-nav-bar>

          <div class="user-wrapper" @click="doLogin()">
            <van-image round class="user_img" :src="userInfo.header_img">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <div class="login-content">
              <p class="login-btn">{{ userInfo.username }}</p>
              <p v-if="userInfo.subtitle" class="login-label">{{ userInfo.subtitle }}</p>
            </div>
          </div>
        </div>

        <div class="content">
          <div style="margin-top: 15px">
            <van-cell @click="refresh()">
              <template>
                <div style="display: flex; justify-content: space-between;">
                  <div class="icons" style="color:#fff;font-size: 14px">
                    <img data-v-920d1dea="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJ6SURBVHgB5VZLkhJBEH3ZDYSs5AjtDiKMkBZ1K9yAOYHMCWY8gdxgZk7AeAL1BODeGNrVzI7yBuwa+VSaWU3HIPIpwN28iIyu7srOV5WVnwKeCmjbxHTK9QWhgiMQMsalEiXwJU1TjsIiegw0cRqMDdEqE5mdpEoYFNGXYSQylllDsmociJUFm1KImIi225hM+fL3nFlklDJHOBK6eLWhttIZd3cqT+fcXyo2cSLETlttTWb8dX0u2PUjM/dFRiIfsAei01zqX+m7zY+F8Hxdt7DHVrSUWzHWladG5E8Rs5xXg3WRtkge6Xsjfh9pS6Qr8n5lAe0turqzG5FrnEJKWbh3dKzuQxaVr/C4GyX6JaLnluyMUl/StQUM5DHAf4A36bB+H9mQriQJvzfuqs6Fw8bDBTM6ZPksTmrG15Y36QyLSsgFPc+2LMClgXXBRRUCqcuNr63AV/Fd8jKR6jTQMRP1pC53lVB2buKk+g0HwGun6loO6AtDqxQJKZqUV1Diyt3rhyHZtBUnsVcgee1UXcsuH2lDDpKbm+NZHZ7wIlXXBpZfWMsttvYs/86Wz/Xbws7jt0ltAE94undYkcj9FGpxYLezbMUhufLIXDCi89HXvV6kMxQjacwdXvsu6dLMx+Lez/DMYy9Sde+P+v05B4jIpQguHCnsDYPGBRuMGkl1AE945+mbpHarT1ckAnKkoaXrQ4rCRlLOaimCwr/t6BGTMbhsdHQMobO/+iI9UNsWaIFLKfAbW5QGS8BprLLNqP4bEHrZS2ZzFbSuPF1giKyFGaLjCrwEWN5fN17ONt4GVy5np8DvNvgXud6T+EhiuUWWi64VPnH8AQHXLP/FPd2dAAAAAElFTkSuQmCC">
                    <span>{{ $t('my.my_balance') }}</span>
                  </div>
                  <div style="display:flex;align-items: center;">
                    <img
                      style="width: 20px; margin-right: 10px"
                      class="refresh"
                      src="data:image/png;base64,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"
                      alt=""
                    >
                    <span style="color:#fff;font-size: 16px">{{ userInfo.money }}</span>
                  </div>
                </div>
              </template>
            </van-cell>

            <div style="margin-top: 15px">
              <van-cell is-link @click="$router.push('/GameRecord')">
                <template>
                  <div class="icons" style="color:#fff;font-size: 14px">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIZSURBVHgB3ZVBVsIwEIbTPjfu8AbsFDfWgu+57A3EE4AnQE5AOQF4AvEE4gm6FyUsfAJuyg3gAnScoQmE2oSK4PP5vzekpJP50ulkythfFHd4rlcaeln9ASCPFqLdyjk76+K5fRjYkRX0nHUgbUKzpIyWR7v6NgwYPOHP5ICxyRLkfrQi+3Ca3ADJsqw2DtfCfq6e83776o6g7444+w0RjCyLb+Y0pokXR7XFBaxSuxcYL44rEbD2IghYfpY1RhiWbQ7NSwdBh64jBs3zwfHD2v3LYT6tSi1mhgU4eGg+VlczDXTRL/jS/8UdVjFgC8NK0ASiqF4anHaNMDqUOITKlD84H9xRqaeBuDtu4JwvFs/iR1lC68X+SduURk+MMwlzuFMjSISLdSC6V+SFIzLyjdmrg617sgBiVdB8WKmi+hFIlj+lMRmHDryhyyz7GmmqzH0B9tz4UOtASenSWBZjV05ggfg4NMXfzgIYLXYxw1Z2U+oXOmqA54s3BzcRoi0b8YEGVhPjWkkTECF02SBgiReqOHeUFsCa2x6LG/EZ0wmDOSJVocFHTWlZ55flfXVEkHtmkAKc0gbZNhIfPEjrHAk/6i6PWwMJYEqhAJTpqQVA1ZXiF6C1NsFkCtsJQFUESAICkU5P8ZfHBjbBQplCtBqsDnYSQPfyzJwhj21w0EkCcmwXotQpwacCUN0ZIAFzxIv39gL41/oEwHc878uPxPAAAAAASUVORK5CYII=" alt="">
                    <span>{{ $t('lottery.reward_record') }}</span>
                  </div>
                </template>
              </van-cell>

              <van-cell is-link @click="$router.push('/WithdrawRecord')">
                <template>
                  <div class="icons" style="color:#fff;font-size: 14px">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJFSURBVHgBnVVdctMwEJaUDgxPmBPgPPKExgzv5gSEE8Q9AeUEmBMETuBwgoYTuH1uwTyRDC9OT5Dw1JlO6mXXXTXbrd2m3ZkdSatP3/7JsjF3CACkqAVqDVuh+SHq2DxG8KBHLQVhxU4Olb1+kBMCo65Yc9SoAxOhZiKjz7sQpyKieAd8zFmRHNwHrDVxlfydVMliIrE/k0URbJxFzZnGErcn5lQ72systctg3DSbM+fcBAkj15x/gsEzrLtJNwa+0D5i10i6j9MStUB9F85aEXnN4KFKypwk89wZi3W1a0RGDRK//fUqV5kTeYr6ghySzfGG56h/aOLqzeKjs/YlolpickDrU/9npKDfeRzpssQ8lpr8Ektg2wMhSXQAJjPO0S2aCeiR4rqKHCVct3+afNCc77snMARr2tsABto12c09sqfWzzWgbeBFG30r1tiiuUC7fUollKWJOsmxAVOsOzXhWAOay+YbOHuMDX3NZFNs6BlAM1NQz2O1jezqfn9ljU2PnCbzDK8jnPh52rUvnoVIRk5NjHn9Hjc/YCa/bx1uzNJaWIMZrDuIKeqUsgrXMGyQzFBH4k3xpkdEpmOex31faEhnxZ+xFw7iHvIKbsqKx3EXODxW4a0IDiiatAMfoqRXcSqckL3oi/7aOzuo2VZyCbwKphJlylRG5XVjVd28sMnIdBlIchWk/MnEulGh3gfCHnG0OaddshY9ZctvkasMoLN+O4gktx2bMQ7U3PBpH6Euze7iWYd3RZDB9po+VNqr/R/IOAT2qcgW+AAAAABJRU5ErkJggg==" alt="">
                    <span>{{ $t('withdraw.with_record') }}</span>
                  </div>
                </template>
              </van-cell>

              <van-cell is-link @click="doWithdrawal()">
                <template>
                  <div class="icons" style="color:#fff;font-size: 14px">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJFSURBVHgBnVVdctMwEJaUDgxPmBPgPPKExgzv5gSEE8Q9AeUEmBMETuBwgoYTuH1uwTyRDC9OT5Dw1JlO6mXXXTXbrd2m3ZkdSatP3/7JsjF3CACkqAVqDVuh+SHq2DxG8KBHLQVhxU4Olb1+kBMCo65Yc9SoAxOhZiKjz7sQpyKieAd8zFmRHNwHrDVxlfydVMliIrE/k0URbJxFzZnGErcn5lQ72systctg3DSbM+fcBAkj15x/gsEzrLtJNwa+0D5i10i6j9MStUB9F85aEXnN4KFKypwk89wZi3W1a0RGDRK//fUqV5kTeYr6ghySzfGG56h/aOLqzeKjs/YlolpickDrU/9npKDfeRzpssQ8lpr8Ektg2wMhSXQAJjPO0S2aCeiR4rqKHCVct3+afNCc77snMARr2tsABto12c09sqfWzzWgbeBFG30r1tiiuUC7fUollKWJOsmxAVOsOzXhWAOay+YbOHuMDX3NZFNs6BlAM1NQz2O1jezqfn9ljU2PnCbzDK8jnPh52rUvnoVIRk5NjHn9Hjc/YCa/bx1uzNJaWIMZrDuIKeqUsgrXMGyQzFBH4k3xpkdEpmOex31faEhnxZ+xFw7iHvIKbsqKx3EXODxW4a0IDiiatAMfoqRXcSqckL3oi/7aOzuo2VZyCbwKphJlylRG5XVjVd28sMnIdBlIchWk/MnEulGh3gfCHnG0OaddshY9ZctvkasMoLN+O4gktx2bMQ7U3PBpH6Euze7iWYd3RZDB9po+VNqr/R/IOAT2qcgW+AAAAABJRU5ErkJggg==" alt="">
                    <span>{{ $t('my.withdraw') }}</span>
                  </div>
                </template>
              </van-cell>

              <van-cell is-link @click="$router.push({ path: '/Setbank' })">
                <template>
                  <div class="icons" style="color:#fff;font-size: 14px">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADTSURBVHgB7ZXBDcIwDEV/UO8wQrhxrOgCMAGMwAiMwgaM0i4A9Mit2QAxQXBEIwWDECGmh4gnWWniqD+OLQf4E4EKJ9bakoYN2RhpXMl2SikDJrCwslzINBepybo+miSCA++5wwnUECL83wgDULB5KRiNJjOvRLxTFC7SUtktIYDLif8eJCf5iBQxmw/zs7tn/WaLqY6zKV+Mi8R+54+KpDo9n/IT8q2uCX5AmBND5lr0lsYWaaxwr8LmYdU9MH17lqLzj5biRyDHGunXZqgHNsiOG7tz9HrNgLbZAAAAAElFTkSuQmCC" alt="">
                    <span>{{ $t('mine.bank_management') }}</span>
                  </div>
                </template>
              </van-cell>

              <van-cell is-link @click="doPay()">
                <template>
                  <div class="icons" style="color:#fff;font-size: 14px">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHXSURBVHgBtVXLUcNADNXaKcAlmGNuYRjupgOoIKGCQAVJKoipAFMB6cDhzMHmBDebCpLcYAZbSLE8rO21QxJ4MxrFK+1brT4bAAIijklWeBgSkiEY0CPDhPSUJBbZFx5JQDyglHqoWORkFgcOAO+TW4cmI+MejgATc4D1dQv+Eb36QnT2NkaAy10bswxn53F/uRd5huCpokidUBa+kFruRW7neJsBUtVVZ4Ft+FzADjTIT+N+SiqFP0CD/Hnw6lm2qgwFYr6xc+XLwQ1Qf1/8ilxZag4Ig8oaNVVmIQ9YAC2gVuQ9LklMh6VGcsr51ZcFowp5rlY2fCw6iHlORtr3aDutxw4REwmHL78TmVjH6tjkyIZEJtBtcS1T6FO0AWl+X7jTnF5HUBFIDqHo+4gOOCGCdc0vFT0kO/d+2QxrY1ro25P1ee37ph6B3DCpPcNTtrVFXka3gd1wRFKSGWu63bI82VhQWovEFuLPHwlH6HLb8R6xhWJrvkcd5EwSaAWdaIfUdWi8E7Y99GZfV8uvK2vbm5n8Oed3JBOJ/r2Fd0155FZLye8Jii4q68Kai+oYOml7uo/dSDRfT8t/KL8fTREpbVNZdSPK90J8p1D0M/vzHFzr9hLf5HwF/zVh/YIAAAAASUVORK5CYII=" alt="">
                    <span>{{ $t('recharge.recharge') }}</span>
                  </div>
                </template>
              </van-cell>

              <van-cell is-link @click="$router.push({ path: '/pickgirl' })">
                <template>
                  <div class="icons" style="color:#fff;font-size: 14px">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHXSURBVHgBtVXLUcNADNXaKcAlmGNuYRjupgOoIKGCQAVJKoipAFMB6cDhzMHmBDebCpLcYAZbSLE8rO21QxJ4MxrFK+1brT4bAAIijklWeBgSkiEY0CPDhPSUJBbZFx5JQDyglHqoWORkFgcOAO+TW4cmI+MejgATc4D1dQv+Eb36QnT2NkaAy10bswxn53F/uRd5huCpokidUBa+kFruRW7neJsBUtVVZ4Ft+FzADjTIT+N+SiqFP0CD/Hnw6lm2qgwFYr6xc+XLwQ1Qf1/8ilxZag4Ig8oaNVVmIQ9YAC2gVuQ9LklMh6VGcsr51ZcFowp5rlY2fCw6iHlORtr3aDutxw4REwmHL78TmVjH6tjkyIZEJtBtcS1T6FO0AWl+X7jTnF5HUBFIDqHo+4gOOCGCdc0vFT0kO/d+2QxrY1ro25P1ee37ph6B3DCpPcNTtrVFXka3gd1wRFKSGWu63bI82VhQWovEFuLPHwlH6HLb8R6xhWJrvkcd5EwSaAWdaIfUdWi8E7Y99GZfV8uvK2vbm5n8Oed3JBOJ/r2Fd0155FZLye8Jii4q68Kai+oYOml7uo/dSDRfT8t/KL8fTREpbVNZdSPK90J8p1D0M/vzHFzr9hLf5HwF/zVh/YIAAAAASUVORK5CYII=" alt="">
                    <span>{{ $t('foorter.pickgirl') }}</span>
                  </div>
                </template>
              </van-cell>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      isLoading: false,
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.$toast(this.$t('common.refresh_success'));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t('my.finish_task'));
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Setting' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t('common.refresh_success'));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    doPay() {
      this.$toast(this.$t('setting.contact_recharge'));
      return false;
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push('withdraw');
        } else {
          this.$router.push('Setbank');
          this.$toast.fail(this.$t('setting.set_bank'));
        }
      })
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push('ServiceOnline');
      } else {
        this.$toast.fail(this.$t('setting.forbid'));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t('video.account_out'));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    initGuestUser() {
      this.userInfo = {
        username: this.$t('setting.log_reg'),
        subtitle: this.$t('setting.more_service'),
        header_img: 'img/mine/avatar.png',
        money: '0.00'
      };
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.initGuestUser();
    }
  }
};
</script>

<style scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
}

.mine {
  position: relative;
  bottom: 10px;
  background-color: #29243d;
}

.mine .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 15vw;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mine .header {
  background-color: #29243d;
}

::v-deep .van-nav-bar__content {
  height: 100px;
  background-color: #29243d;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0;
}

.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}

.mine .header .user-wrapper {
  display: flex;
  align-items: center;
  padding: 30px 40px;
  margin-bottom: .4rem;
  font-size: .42667rem;
  line-height: .74667rem;
  border-radius: .13333rem;
  color: #fff;
  background: #342f46;
  flex-direction: column;
}

.mine .user_img {
  height: 130px;
  width: 130px;
}

::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}

::v-deep .van-image__error-icon {
  font-size: 70px;
}

.mine .header .user-wrapper .login-content {
  flex: 1;
}

.mine .header .user-wrapper .login-content .login-btn {
  display: inline-block;
  font-size: 40px;
  margin-top: 50px;
  line-height: 1.2;
  color: #fff;
}

.mine .header .user-wrapper .login-content .login-label {
  margin-top: 10px;
  font-size: 28px;
  color: hsla(0, 0%, 100%, .6);
  text-align: center;
}

.mine .page-bg {
  height: 500px;
}

.mine .content {
  position: relative;
  padding: 1rem;
  background-color: #29243d;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #ffffff;
  font-size: 35px;
}

::v-deep .van-tabbar-item--active {
  color: #ddb285 !important;
}

::v-deep .van-icon-peer-pay:before,
::v-deep .van-icon-idcard:before {
  color: #e6b98a;
}

::v-deep [class*=van-hairline]::after {
  border: 0 solid #e6b98a;
}

::v-deep .van-cell {
  margin-bottom: .4rem;
  font-size: .82667rem;
  line-height: 1rem;
  border-radius: .53333rem;
  color: #fff;
  background: #342f46;
  padding: 1rem .37333rem;
}

::v-deep .van-cell__title span {
  color: #fff;
  font-size: 28px;
  margin-left: 10px;
}

::v-deep .van-cell__left-icon {
  font-size: 60px;
  color: #e6b98a;
}

::v-deep .van-cell__right-icon {
  font-size: 40px;
  line-height: 1.5rem;
}

::v-deep .van-cell::after {
  border: none;
}

p {
  padding: 0;
  margin: 0;
  color: #fff;
  line-height: 30px;
  font-size: 24px;
}

.icons {
  display: flex;
  align-items: center;
}

.icons img {
  width: 48px;
  margin-right: 10px;
}
</style>
